import MetricBase from "models/metrics/MetricBase";
import ConversionGroup from "models/groups/ConversionGroup";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";

class MetricConversionGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_conversion_rate",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.conversion.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.conversion.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.conversion.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricConversionGhaPPA;
